import loadable from 'components/dynamic-import';
import { PagesModules } from '@streamloots/streamloots-types';

const PublicModuleLanding = loadable(() => import('./PublicModuleLanding'));

export const CardsModulePublicLandingPage = (): JSX.Element => {
  return <PublicModuleLanding module={PagesModules.Cards} />;
};
